export default "__VITE_ASSET__DsqpDimw__"